import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import Footer from "../layout/footer";

const bg = require("../../images/servicehero.png");

class OfficeCleaning extends Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr  bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Office Cleaning</h1>
                <div className="breadcrumb-row">
                  {/* <ul className="list-inline">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>Service</li>
                    <li>Service Details</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <div className="widget sidebar-widget ext-sidebar-menu widget_nav_menu">
                      <ul className="menu">
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/airbnb-cleaning"
                          >
                            Airbnb Property Management
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/residential-cleaning"
                          >
                            Residential Cleaning
                          </Link>{" "}
                        </li>
                        <li className="active">
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/office-cleaning"
                          >
                            Office Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/school-and-medical-cleaning"
                          >
                            School And Medical Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/bond-cleaning"
                          >
                            Bond Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/window-cleaning"
                          >
                            Window Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/special-event-cleaning"
                          >
                            Special Event Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/carpet-steam-cleaning"
                          >
                            Carpet Steam Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/spring-cleaning"
                          >
                            Spring Cleaning
                          </Link>{" "}
                        </li>
                      </ul>
                    </div>
                    {/* <div className="widget">
                      <div className="download-file">
                        <h4 className="title">Get your brochures</h4>
                        <ul>
                          <li>
                            <Link to="#" target="_blank">
                              <div className="text">Company Brochures</div>
                              <i className="fa fa-download"></i>
                            </Link>
                          </li>
                          <li>
                            <Link to="#" target="_blank">
                              <div className="text">Company Info</div>
                              <i className="fa fa-download"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        {/* <div className="dlab-media">
                            {" "}
                            <Link to="#">
                              <img
                                src={require("../../images/about/pic4.jpg")}
                                alt=""
                              />
                            </Link>{" "}
                          </div> */}
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Enhance your office environment to create a
                              positive physical and mental well-being by
                              obtaining the services of a professional
                              commercial cleaning service in Gold Coast, QLD
                            </Link>
                          </h4>
                          <p>
                            Good office cleaning procedures boost satisfaction
                            among employees. Work becomes a source of motivation
                            and happiness. People who are content at work are
                            more productive and more committed to their employer
                            and take fewer sick days, prevent burnout, and have
                            higher job satisfaction.
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Cleaning Offices for Mental and Physical
                              Well-being
                            </Link>
                          </h4>
                          <p>
                            Many distinct factors influence job happiness. Some
                            people experience it while they are making
                            significant progress. Others encounter it when they
                            remain behind to support one another. Most people
                            experience it when they feel appreciated.
                          </p>
                          <p>
                            The crucial role of a clean, safe, and hygienic
                            atmosphere in creating a sense of value in people
                            cannot be overstated.
                          </p>
                          <p>
                            According to studies, higher standards of office
                            hygiene correlate with increased productivity.
                            Hence, as a business owner, it is necessary to
                            implement thorough hygiene practices and standards
                            to ensure your people experience a clean, positive
                            environment daily. A spotless office is also the key
                            to creating lasting impressions for your customers.
                            As we are all aware, more and more organizations now
                            focus on and support improving mental health in the
                            workplace. Did you know that cleaner workspaces can
                            reduce stress levels? Employees can concentrate even
                            during long hours and relax during working hours
                            with decreased stress. A pleasant, cleaner work
                            environment is critical to a safer workplace.
                          </p>
                          <p>
                            Creating happy employees with a cleaner environment
                            further lowers staff turnover and reduces the cost
                            of hiring new employees. Hiring a professional
                            commercial cleaning service helps you achieve a
                            top-notch pristine office for a reasonable price.
                          </p>
                        </div>
                      </div>

                      <div className="dlab-box">
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Efficient Commercial Cleaning Services at Gold
                              Coast Kangaroo Shine Property Services
                            </Link>
                          </h4>
                          <p>
                            With experienced staff in cleaning a range of office
                            settings, we know how an office's operations and
                            layouts change for the benefit of its workers. While
                            a structured scope of work will serve as the general
                            framework for the commercial cleaning service and
                            methods for optimization, including agile and
                            predictive maintenance, we at Gold Coast Kangaroo
                            Shine Property Services in Gold Coast create a new
                            cleaning solution that is tailored to your company's
                            needs.
                          </p>
                          <p>
                            Our Gold Coast, Queensland, commercial cleaning
                            services will focus on results that enhance employee
                            well-being, workplace safety, and corporate
                            performance.
                          </p>
                          <p>
                            We have special disinfection services with higher
                            quality standards to disinfect your office. To learn
                            more about how we can help you at Kangaroo Shine
                            Property Services in Gold Coast, QLD, please call or
                            message us at +61424888804, and we will contact you
                            soon.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default OfficeCleaning;
